// hooks/usePremiumField.tsx
import React from "react";
import { Group, Badge, Tooltip } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";

interface UsePremiumFieldOptions {
  label: React.ReactNode;
  description?: string;
  /** false = locked, true = unlocked premium, null/undefined = not a premium feature */
  premiumFeatureEnabled?: boolean | null;
  /** Plan name(s) required for this feature */
  requiredPlans?: string | string[];
}

export const usePremiumField = ({
  label,
  description,
  premiumFeatureEnabled,
  requiredPlans,
}: UsePremiumFieldOptions) => {
  const isLocked = premiumFeatureEnabled === false;

  if (!isLocked) {
    return { label, description, disabled: false, isLocked: false };
  }

  // Build plan display text
  const plans = requiredPlans
    ? Array.isArray(requiredPlans)
      ? requiredPlans
      : [requiredPlans]
    : null;

  const planText = plans?.join(" / ") ?? "Premium";

  const tooltipText = plans
    ? `Available on ${plans.join(", ")} plan${plans.length > 1 ? "s" : ""}`
    : "Upgrade your plan to unlock this feature";

  const descriptionPrefix = plans
    ? `Available on ${plans.join(", ")} plan${plans.length > 1 ? "s" : ""}.`
    : "Upgrade your plan to enable this feature.";

  return {
    label: (
      <Group gap={6}>
        {label}
        <Tooltip label={tooltipText}>
          <Badge
            size="xs"
            variant="light"
            color="yellow"
            leftSection={<IconLock size={10} />}
          >
            {planText}
          </Badge>
        </Tooltip>
      </Group>
    ),
    description: description
      ? `${descriptionPrefix} ${description}`
      : descriptionPrefix,
    disabled: true,
    isLocked: true,
  };
};
